import { NavigationSetWithFlag } from "types/tags";

export interface NavigationItem {
  title: string;
  link: string;
}

export const getNavigationItems = (
  navigationSets: NavigationSetWithFlag[],
  activeAccountTags?: string[]
): NavigationItem[] => {
  // Check if data is from Algolia (useTags: false) or DatoCMS (useTags: true)
  // Algolia backend already handles tag filtering, so show all items
  // DatoCMS requires frontend tag filtering
  // Must explicitly check for false, not just falsy (undefined would be treated as DatoCMS)
  const isAlgoliaSource =
    navigationSets.length > 0 && navigationSets[0].useTags === false;

  let setsToUse: NavigationSetWithFlag[];

  if (isAlgoliaSource) {
    // Algolia: show all items (backend already filtered by tags)
    setsToUse = navigationSets;
  } else {
    // DatoCMS: apply tag filtering
    if (!activeAccountTags) return [];
    setsToUse = navigationSets.filter((navigationSet) =>
      navigationSet.availableTags?.some((availableTag) =>
        activeAccountTags.includes(availableTag.tagValue || "")
      )
    );
  }

  //We need to make sure we don't add the same item twice because an user can have multiple tags
  //with navigation items that are the same
  const itemsIDs: Set<string> = new Set();
  const items: NavigationItem[] = [];

  setsToUse.forEach((set) => {
    set.navigationHeader?.navigationItem.forEach((item) => {
      if (!itemsIDs.has(item.id)) {
        items.push({
          title: item.title || "",
          link:
            item.__typename === "NavigationLinkRecord"
              ? `/${item.url}` || ""
              : `/category/${item.slug}` || "",
        });
        itemsIDs.add(item.id);
      }
    });
  });

  return items;
};
